// // src/Pages/ConsigneeDetails.jsx
// import React, { useState, useEffect, Suspense, useCallback } from "react";
// import axios from "axios";
// import { Link as RouterLink, useNavigate } from "react-router-dom";
// import { Box, Grid, Paper, Typography, TextField, Button, Checkbox, IconButton, LinearProgress, useMediaQuery, useTheme } from "@mui/material";
// import { FilterList as FilterListIcon, Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
// import { FaFileExcel } from "react-icons/fa";
// import { DataGrid } from "@mui/x-data-grid";
// import { useAuth } from '../context/AuthContext';

// const ConsigneeCard = React.lazy(() => import("../components/ConsigneeCard"));

// /* ---------- Parent Page ---------- */
// export default function ConsigneeDetails({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const path = `${connectionString}/api/consignee`;
//     const userId = user?.UserId;
//     const companyId = selectedCompany?.CompId;
//     const [filters, setFilters] = useState({ conName: "", city: "", state: "", pincode: "", gstno: "", mobile: "" });
//     const [showFilter, setShowFilter] = useState(false);
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
//     const isMedium = useMediaQuery(theme.breakpoints.between("sm", "md"));
//     const showCardView = isSmall || isMedium;

//     const [items, setItems] = useState([]);
//     const [total, setTotal] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [selected, setSelected] = useState(new Set());

//     // Fetch matching records (we request a high limit so DataGrid shows most matches).
//     const loadItems = useCallback(async () => {
//         setLoading(true);
//         try {
//             // send only non-empty filters
//             const filteredParams = Object.entries(filters || {})
//                 .filter(([_, value]) => value !== undefined && value !== null && String(value).trim() !== "")
//                 .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

//             const params = {
//                 ...filteredParams,
//                 userId, companyId,
//                 mode: "search"
//             };

//             const resp = await axios.get(`${path}/search`, {
//                 params,
//                 validateStatus: s => s >= 200 && s < 400,
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });

//             const data = resp.data;
//             console.log("data:", data);
//             if (Array.isArray(data)) {
//                 setItems(data);
//                 setTotal(data.length);
//             } else if (data && Array.isArray(data.data)) {
//                 // some APIs return { data: [...] }
//                 setItems(data.data);
//                 setTotal(data.data.length);
//             } else {
//                 setItems([]);
//                 setTotal(0);
//             }
//         } catch (err) {
//             console.error("Error loading consignees:", err);
//             setItems([]);
//             setTotal(0);
//         } finally {
//             setLoading(false);
//             // clear selection whenever items change
//             setSelected(new Set());
//         }
//     }, [filters]);

//     useEffect(() => {
//         loadItems();
//     }, [loadItems]);

//     const toggle = id => setSelected(s => {
//         const next = new Set(s);
//         next.has(id) ? next.delete(id) : next.add(id);
//         return next;
//     });

//     const handleCardClick = (conId) => { navigate(`/main/edit-consignee/${conId}`); };

//     const selectAll = () => setSelected(s => {
//         if (s.size === items.length && items.length > 0) return new Set();
//         return new Set(items.map(i => i.ConID));
//     });

//     const handleExport = () => {
//         axios.get(`${path}/search`, {
//             params: { mode: "export" },
//             responseType: "blob"
//         }).then(res => {
//             const url = URL.createObjectURL(new Blob([res.data]));
//             const a = document.createElement("a");
//             a.href = url;
//             a.download = "consignee.xlsx";
//             a.click();
//         }).catch(console.error);
//     };

//     // DataGrid columns (desktop)
//     const columns = [
//         { field: "index", headerName: "#", width: 40, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 return params.api.getAllRowIds().indexOf(params.id) + 1;
//             },
//         },
//         { field: "clientDetails", headerName: "Client Name", flex: 2, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 const client = params.row;
//                 return (
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                         {/* Wrap Typography in a RouterLink to make it a clickable link */}
//                         <RouterLink
//                             to="/main/consignee-master"
//                             state={{ clientId: client.clientId, clientFirmName: client.clientFirmName }} // Pass clientId and clientFirmName in the state
//                             style={{ textDecoration: "none" }} // Remove default underline for cleaner look
//                         >
//                             <Typography variant="subtitle2" fontWeight="bold"
//                                 sx={{
//                                     color: "#1a0dab", // Google-like blue color for the link
//                                     "&:hover": {
//                                         textDecoration: "underline", // Underline on hover like Google links
//                                     },
//                                 }}
//                             >
//                                 {client.clientFirmName}
//                             </Typography>
//                         </RouterLink>
//                     </Box>
//                 );
//             },
//         },
//         { field: "clientContactPerson", headerName: "Contact", flex: 0.6 },
//         { field: "clientMobileNo", headerName: "Mobile", flex: 0.5 },
//         { field: "clientCity", headerName: "City", flex: 0.5 },
//         { field: "clientState", headerName: "State", flex: 0.5 },
//         { field: "clientGSTNo", headerName: "GST No.", flex: 0.8 },
//     ];

//     return (
//         <Box sx={{ p: 0, marginX: 1 }}>
//             {/* Header Buttons */}
//             <Paper sx={{ p: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center", }} >
//                 {/* Left: buttons */}
//                 <Box display="flex" alignItems="center" gap={2}>
//                     <IconButton component={RouterLink} to="/main/consignee-master" color="primary" >
//                         <AddIcon />
//                     </IconButton>
//                     <IconButton onClick={handleExport} color="success">
//                         <FaFileExcel />
//                     </IconButton>
//                 </Box>

//                 {/* Center: title */}
//                 <Typography variant="h6" fontWeight="bold" sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }} >
//                     Consignee Details
//                 </Typography>

//                 {/* Right: empty box to balance spacing */}
//                 <Box width={60} /> {/* keeps title centered */}
//             </Paper>

//             {/* Desktop: DataGrid */}
//             {!showCardView && (
//                 <Paper sx={{ height: '85vh', width: "100%", }}>
//                     {/* DataGrid with auto row height and wrapping */}
//                     <DataGrid
//                         autoHeight
//                         rows={items.map(r => ({ ...r, id: r.ConID }))}
//                         columns={columns}
//                         pageSize={50}
//                         rowsPerPageOptions={[50, 100, 150]}
//                         onRowDoubleClick={(params) => handleCardClick(params.row.ConID)}
//                         loading={loading}
//                         // Let the grid compute row height automatically:
//                         getRowHeight={() => 'auto'}
//                         sx={{
//                             "& .MuiDataGrid-columnHeaders": { backgroundColor: "#165bb5", color: "#fff", fontWeight: "bold" },
//                             "& .MuiDataGrid-row:nth-of-type(odd)": { backgroundColor: "#fff" },
//                             "& .MuiDataGrid-row:nth-of-type(even)": { backgroundColor: "#f6f9ff" },
//                             // Allow cells to wrap and give reasonable padding so auto height works
//                             "& .MuiDataGrid-cell": { whiteSpace: "normal", lineHeight: 1.2, py: "8px", alignItems: "start", },
//                             // Ensure the cell content uses full width and normal wrapping
//                             "& .MuiDataGrid-cell > div": { width: "100%", display: "block", },
//                         }}
//                     />
//                 </Paper>
//             )}

//             {/* Mobile / Medium: Cards */}
//             {showCardView && (
//                 <>
//                     {items.length === 0 && !loading && (
//                         <Typography align="center" color="text.secondary" sx={{ mt: 4 }}>
//                             No records found.
//                         </Typography>
//                     )}

//                     {items.map((c, i) => (
//                         <Suspense fallback={<LinearProgress />} key={c.ConID}>
//                             <ConsigneeCard consignee={c} index={i} selected={selected.has(c.ConID)} onSelect={() => toggle(c.ConID)} onClick={handleCardClick} />
//                         </Suspense>
//                     ))}
//                 </>
//             )}
//         </Box>
//     );
// }











// import React, { useState, useEffect, Suspense, useCallback } from "react";
// import axios from "axios";
// import { Link as RouterLink, useNavigate } from "react-router-dom";
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card, CardContent, Checkbox, useMediaQuery, useTheme, LinearProgress, Avatar} from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { FaFileExcel } from "react-icons/fa";
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import PhoneIcon from '@mui/icons-material/Phone';
// import PersonIcon from '@mui/icons-material/Person';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import { VscNewFile } from "react-icons/vsc";
// import { useAuth } from '../context/AuthContext';
// import TextField from '@mui/material/TextField';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';

// const ConsigneeCard = React.lazy(() => import("../components/ConsigneeCard"));

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function ConsigneeDetails({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const path = `${connectionString}/api/consignee`;
//     const userId = user?.UserId;
//     const companyId = selectedCompany?.CompId;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     const [filters, setFilters] = useState({ conName: "", city: "", state: "", pincode: "", gstno: "", mobile: "" });
//     const [items, setItems] = useState([]);
//     const [total, setTotal] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [selected, setSelected] = useState(new Set());
//     const [selectAll, setSelectAll] = useState(false);
//     const navigate = useNavigate();

//     const loadItems = useCallback(async () => {
//         setLoading(true);
//         try {
//             const filteredParams = Object.entries(filters || {}).filter(([_, value]) => value !== undefined && value !== null && String(value).trim() !== "").reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

//             const params = { ...filteredParams, userId, companyId, mode: "search" };

//             const resp = await axios.get(`${path}/search`, {
//                 params,
//                 validateStatus: s => s >= 200 && s < 400,
//                 headers: { 'Cache-Control': 'no-store' }
//             });

//             const data = resp.data;
//             if (Array.isArray(data)) {
//                 setItems(data);
//                 setTotal(data.length);
//             } else if (data && Array.isArray(data.data)) {
//                 setItems(data.data);
//                 setTotal(data.data.length);
//             } else {
//                 setItems([]);
//                 setTotal(0);
//             }
//             setSelected(new Set());
//             setSelectAll(false);
//         } catch (err) {
//             console.error("Error loading consignees:", err);
//             setItems([]);
//             setTotal(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [filters, userId, companyId]);

//     useEffect(() => {
//         loadItems();
//     }, [loadItems]);

//     const toggle = (id) => {
//         setSelected(s => {
//             const next = new Set(s);
//             next.has(id) ? next.delete(id) : next.add(id);
//             return next;
//         });
//     };

//     const selectAllToggle = () => {
//         if (selectAll) {
//             setSelected(new Set());
//             setSelectAll(false);
//         } else {
//             setSelected(new Set(items.map(i => i.ConID)));
//             setSelectAll(true);
//         }
//     };

//     const handleDelete = async () => {
//         if (selected.size === 0) return;
//         try {
//             await axios.post(`${path}/delete`, { userId, companyId, objAryId: Array.from(selected) });
//             setSelected(new Set());
//             setSelectAll(false);
//             loadItems();
//         } catch (err) {
//             console.error("Delete error:", err);
//         }
//     };

//     const handleExport = () => {
//         axios.get(`${path}/search`, {
//             params: { mode: "export" },
//             responseType: "blob"
//         }).then(res => {
//             const url = URL.createObjectURL(new Blob([res.data]));
//             const a = document.createElement("a");
//             a.href = url;
//             a.download = "consignee.xlsx";
//             a.click();
//         }).catch(console.error);
//     };

//     const handleCardClick = (ConID) => {
//         navigate(`/main/edit-consignee/${ConID}`, { state: { clientId: ConID } });
//     };


//     const columns = [
//         {
//             field: "index", headerName: "#", width: 40, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 return params.api.getAllRowIds().indexOf(params.id) + 1;
//             },
//         },
//         {
//             field: "clientDetails", headerName: "Client Name", flex: 2, sortable: false, filterable: false,
//             renderCell: (params) => {
//                 const client = params.row;
//                 return (
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
//                         <RouterLink to="/main/consignee-master" state={{ clientId: client.clientId, clientFirmName: client.clientFirmName }} style={{ textDecoration: "none" }} >
//                             <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "#1a0dab", "&:hover": { textDecoration: "underline" }, }} >
//                                 {client.clientFirmName}
//                             </Typography>
//                         </RouterLink>
//                     </Box>
//                 );
//             },
//         },
//         { field: "clientContactPerson", headerName: "Contact", flex: 0.6 },
//         { field: "clientMobileNo", headerName: "Mobile", flex: 0.5 },
//         { field: "clientCity", headerName: "City", flex: 0.5 },
//         { field: "clientState", headerName: "State", flex: 0.5 },
//         { field: "clientGSTNo", headerName: "GST No.", flex: 0.8 },
//     ];

//     const renderCards = () => {
//         if (loading) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading...</Typography>;
//         if (items.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}>No records found.</Typography>;

//         return items.map((c) => {
//             const isSelected = selected.has(c.ConID);
//             const avatarColor = stringToColor(c.clientFirmName || 'C');
//             const initials = getInitials(c.clientFirmName);

//             const locationText = [c.clientCity, c.clientState].filter(Boolean).join(', ') || '—';

//             return (
//                 <Card key={c.ConID} onClick={() => handleCardClick(c.ConID)} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, borderLeft: '4px solid', borderLeftColor: 'primary.main' }} >
//                     <CardContent sx={{ py: 1.8, px: 2, pb: '12px !important' }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                                 {role !== 'User' && (
//                                     <Checkbox checked={isSelected} onChange={() => toggle(c.ConID)} onClick={(e) => e.stopPropagation()} size="small" sx={{ mr: 1, p: 0.5 }} />
//                                 )}
//                                 <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, fontWeight: 'bold', mr: 1.5, flexShrink: 0 }} >
//                                     {initials}
//                                 </Avatar>
//                                 <Box sx={{ minWidth: 0, flexGrow: 1 }}>
//                                     <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.primary' }} >
//                                         {c.clientFirmName || '—'}
//                                     </Typography>
//                                     <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.3 }} >
//                                         {locationText}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Box>

//                         <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
//                             <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <PersonIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
//                                     <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
//                                         {c.clientContactPerson || '—'}
//                                     </Typography>
//                                 </Box>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <PhoneIcon fontSize="small" sx={{ color: 'primary.main', mr: 1 }} />
//                                     <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}>
//                                         {c.clientMobileNo || '—'}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <ReceiptIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
//                                 <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
//                                     GST: {c.clientGSTNo || '—'}
//                                 </Typography>
//                             </Box>
//                         </Box>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Box sx={{ p: 1, ml: 2 }}>
//             {/* Header Buttons */}
//             <Paper sx={{ p: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <Box display="flex" alignItems="center" gap={2}>
//                     <IconButton component={RouterLink} to="/main/consignee-master" color="primary">
//                         <AddIcon />
//                     </IconButton>
//                     <IconButton onClick={handleExport} color="success">
//                         <FaFileExcel />
//                     </IconButton>
//                 </Box>

//                 <Typography variant="h6" fontWeight="bold" sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
//                     Consignee Details
//                 </Typography>

//                 <Box width={60} />
//             </Paper>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', mt: 2 }}>
//                 <Box sx={{ p: { xs: 1, md: 2 } }}>
//                     {/* Search Field */}
//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2, px: 1 }}>
//                             <TextField fullWidth size="small" placeholder="Search by name, city, mobile..." value={filters.conName} onChange={(e) => setFilters(f => ({ ...f, conName: e.target.value }))}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Box>
//                     )}

//                     {/* Bulk Action Bar */}
//                     {isSmallScreen && role !== 'User' && selected.size > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={selectAllToggle} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>
//                                     {selected.size} selected
//                                 </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={handleDelete} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {/* Desktop: DataGrid */}
//                     {!isSmallScreen && (
//                         <Box sx={{ height: '80vh', width: '100%' }}>
//                             <DataGrid autoHeight={false} rows={items.map(r => ({ ...r, id: r.ConID }))} columns={columns} pageSize={50} rowsPerPageOptions={[50, 100, 150]} onRowDoubleClick={(params) => handleCardClick(params.row.ConID)} loading={loading} getRowHeight={() => 'auto'}
//                                 sx={{
//                                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#165bb5", color: "#fff", fontWeight: "bold" },
//                                     "& .MuiDataGrid-row:nth-of-type(odd)": { backgroundColor: "#fff" },
//                                     "& .MuiDataGrid-row:nth-of-type(even)": { backgroundColor: "#f6f9ff" },
//                                     "& .MuiDataGrid-cell": { whiteSpace: "normal", lineHeight: 1.2, py: "8px", alignItems: "start" },
//                                     "& .MuiDataGrid-cell > div": { width: "100%", display: "block" },
//                                 }}
//                             />
//                         </Box>
//                     )}

//                     {/* Mobile: Cards */}
//                     {isSmallScreen && (
//                         <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
//                             {renderCards()}
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>
//         </Box>
//     );
// }














import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import {
    Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card, CardContent, Checkbox, useMediaQuery, useTheme, CircularProgress, Avatar, TextField, InputAdornment, Dialog, Button,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { FaFileExcel } from "react-icons/fa";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchIcon from '@mui/icons-material/Search';
import { VscNewFile } from "react-icons/vsc";
import { useAuth } from '../context/AuthContext';
import CommonServerDataGrid from '../components/datagridComponent';
import { formatRows } from "../utils/formatRows";
import NoDataComponent from "../components/NoDataComponent";
import CenterLoader from "./Test/components/CenterLoader";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";

/**
 * Utility: Convert string to color
 */
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

/**
 * Utility: Get initials from name
 */
function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

/**
 * ConsigneeDetails Component
 * 
 * Displays consignees in two views:
 * - Desktop: CommonServerDataGrid with pagination, filtering, sorting
 * - Mobile: Card view with search and pagination
 * 
 * Features:
 * - Server-side pagination, filtering, sorting
 * - Search functionality for mobile view
 * - Bulk deletion
 * - Excel export
 * - Responsive design
 */
export default function ConsigneeDetails({ connectionString }) {
    const { user, selectedCompany } = useAuth();
    const API = `${connectionString}/api/consignee`;
    const userId = user?.UserId;
    const companyId = selectedCompany?.CompId;
    const role = user?.UserCategory;
    const navigate = useNavigate();



    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));


    // ============ STATE MANAGEMENT ============

    // Shared state for both views
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState(new Set());
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [selectAll, setSelectAll] = useState(false);
    const [isFiltered, setIsFiltered] = useState(false);
    const[totalDeleted , setTotalDeleted] = useState(0)

    // Desktop state (DataGrid)
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // Mobile state (Search + Pagination)
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

    const [confirmOpen, setConfirmOpen] = useState(false);

    console.log('=== COMPONENT RENDER ===');
    console.log('isSmallScreen:', isSmallScreen);
    console.log('mobileSearchQuery:', mobileSearchQuery);
    console.log('debouncedMobileSearch:', debouncedMobileSearch);
    console.log('rows count:', rows.length);
    console.log('totalCount:', totalCount);
    // console.log("selecttionModal" , selectionModel.size)

    // ============ PARAMETER BUILDERS ============

    /**
     * Build parameters for mobile search request
     */
    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * 20;
        const params = { mode: 'search', userId, companyId, offset, limit: 20 };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        console.log('📦 buildMobileParams:', params);
        return params;
    };

    /**
     * Build parameters for desktop request with filters and sort
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = { mode: 'search', userId, companyId, offset, limit: pageSize };

        // Add filters from DataGrid
        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'clientFirmName': params.search = item.value;
                        break;
                    case 'ConName': params.search = item.value;
                        break;
                    case 'clientCity': params.search = item.value;
                        break;
                    case 'clientState': params.search = item.value;
                        break;
                    case 'clientGSTNo': params.search = item.value;
                        break;
                    case 'clientMobileNo': params.search = item.value;
                        break;
                    case 'clientContactPerson': params.search = item.value;
                        break;
                    default: break;
                }
            }
        });

        // Add sorting
        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log('🖥️ buildDesktopParams:', params);
        return params;
    };

    // ============ FETCH FUNCTIONS ============

    /**
     * Fetch data for desktop view (with filters and sort)
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) return;

        console.log('🖥️ [DESKTOP] Fetching data...');
        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            // Fetch rows
            const dataRes = await axios.get(`${API}/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : (dataRes.data?.data || []);
            setRows(formatRows(fetchedRows));
            setSelectionModel(new Set());

            console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { userId, companyId };

            // Add same filters as search
            filterModel.items.forEach(item => {
                if (item.value) {
                    switch (item.field) {
                        case 'clientFirmName': countParams.clientName = item.value;
                            break;
                        case 'ConName': countParams.ConName = item.value;
                            break;
                        case 'clientCity': countParams.City = item.value;
                            break;
                        case 'clientState': countParams.State = item.value;
                            break;
                        case 'clientGSTNo': countParams.GSTNo = item.value;
                            break;
                        case 'clientMobileNo': countParams.Mobile = item.value;
                            break;
                        default: break;
                    }
                }
            });

            const countRes = await axios.get(`${API}/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`🖥️ Total count: ${count}`);
        } catch (err) {
            console.error('🖥️ Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, userId, companyId, paginationModel, filterModel, sortModel, isSmallScreen]);

    /**
     * Fetch data for mobile view (with search only)
     */
    const fetchDataMobile = useCallback(async () => {
        console.log('📱 [MOBILE] Fetching data...');

        if (!isSmallScreen) {
            console.log('📱 Skipping - not small screen');
            return;
        }

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            console.log('📱 API URL:', `${API}/search`);
            console.log('📱 Params:', JSON.stringify(params, null, 2));

            // Fetch rows
            const dataRes = await axios.get(`${API}/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : (dataRes.data?.data || []);
            setRows(formatRows(fetchedRows));
            setSelectionModel(new Set());

            console.log(`>>>>>>>>>>>>📱 Fetched ${fetchedRows} rows`);

            // Fetch total count
            const countParams = { userId, companyId };
            if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
                countParams.search = debouncedMobileSearch;
            }

            console.log('📱 Count params:', countParams);
            const countRes = await axios.get(`${API}/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`📱 Total count: ${count}`);
        } catch (err) {
            console.error('📱 Fetch error:', err);
            console.error('📱 Error response:', err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, userId, companyId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

    // ============ EFFECTS ============

    /**
     * Trigger desktop fetch when pagination, filters, or sort changes
     */
    useEffect(() => {
        console.log('💻 [EFFECT] Desktop dependencies changed');
        if (!isSmallScreen) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    /**
     * Trigger mobile fetch when pagination changes
     */
    useEffect(() => {
        console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

    /**
     * Debounce mobile search and trigger fetch
     */
    useEffect(() => {
        console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

        const timer = setTimeout(() => {
            console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 400);

        return () => {
            console.log('⏱️ [DEBOUNCE] Cleared timeout');
            clearTimeout(timer);
        };
    }, [mobileSearchQuery]);

    /**
     * Trigger fetch when debounced search changes
     */
    useEffect(() => {
        console.log('📱 [EFFECT] Debounced search changed:', debouncedMobileSearch);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

    // ============ DELETE HANDLER ============

    const handleDelete = async () => {
        if (selectionModel.size === 0) return;

        try {
            const response = await axios.post(`${API}/delete`, { userId, companyId, objAryId: Array.from(selectionModel) });

            setSnackbar({ open: true, message:'Deleted successfully.', severity: 'success' });
            setTotalDeleted(response?.data?.affectedRows)
            setSelectionModel(new Set());
            setSelectAll(false);
            
            // Refetch data
            if (isSmallScreen) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;   
            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Cannot delete the selected item(s) because they are referenced in other records.",
                    severity: "warning"
                });
            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({
                    open: true,
                    message: data.error,
                    severity: "warning"
                });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({
                    open: true,
                    message: "Delete failed due to an unexpected error.",
                    severity: "error"
                });
            }
        } finally {
            setConfirmOpen(false);
        }
    };

    // ============ EXPORT HANDLER ============

    const handleExport = () => {
        axios({ url: `${API}/search?mode=export&userId=${userId}&companyId=${companyId}`, method: 'GET', responseType: 'blob', })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exportedConsignees.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((error) => {
                console.error('Export error:', error);
                setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
            });
    };

    // ============ SELECT ALL TOGGLE ============

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel(new Set());
            setSelectAll(false);
        } else {
            const allIds = rows.map(row => row.ConID);
            setSelectionModel(new Set(allIds));
            setSelectAll(true);
        }
    };

    // ============ TOGGLE SELECTION ============

    const toggleSelection = (id) => {
        setSelectionModel(s => {
            const next = new Set(s);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    // ============ COLUMNS DEFINITION ============

    const columns = [
        {
            field: 'clientFirmName', headerName: 'Client Name', flex: 1.5, minWidth: 150,
            renderCell: (params) => (
                <Typography onClick={() => { navigate(`/main/edit-consignee/${params.row.ConID}/${params.row.PartyID}`, { state: { partyId: params.row.PartyID } }); }}
                    sx={{ cursor: 'pointer', color: '#1a0dab', textDecoration: 'underline', fontSize: '0.85rem' }}
                >
                    {params.value}
                </Typography>
            )
        },
        {
            field: 'ConName', headerName: 'Consignee Name', flex: 1, minWidth: 120, renderCell: (params) => (
                <Typography sx={{ fontSize: '0.85rem', whiteSpace: "normal", wordBreak: "break-word" }}
                >
                    {params.value}
                </Typography>
            )
        },
        {
            field: 'clientContactPerson', headerName: 'Contact Person', flex: 0.8, minWidth: 120, renderCell: (params) => (
                <Typography sx={{ fontSize: '0.85rem', whiteSpace: "normal", wordBreak: "break-word" }}
                >
                    {params.value}
                </Typography>
            )
        },
        { field: 'clientMobileNo', headerName: 'Mobile', flex: 0.5, minWidth: 110 },
        { field: 'clientCity', headerName: 'City', flex: 0.5, minWidth: 100 },
        { field: 'clientState', headerName: 'State', flex: 0.5, minWidth: 100 },
        { field: 'clientGSTNo', headerName: 'GST No.', flex: 0.6, minWidth: 120 },
    ];

    // Add delete button column if not User
    if (role !== "User") {
        columns.push({
            flex: 0.15, sortable: false, filterable: false, headerAlign: 'right', align: 'right',
            renderCell: (params) => {
                const isRowSelected = selectionModel instanceof Set ? selectionModel.has(params.row.ConID) : selectionModel.includes(params.row.ConID);

                return (
                    <Tooltip title={isRowSelected ? 'Delete Selected' : 'Select row to enable'}>
                        <span>
                            <IconButton color="error" 
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setConfirmOpen(true);
                            }} disabled={!isRowSelected} >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        });
    }

    // ============ CARD RENDERING (MOBILE) ============

    const renderCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography sx={{ color: 'text.secondary', mb: 2 }}>
                        {mobileSearchQuery ? <CustomNoDataOverlay/> : <NoDataComponent />}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                        Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {rows.map((row) => {
                    const isSelected = selectionModel.has(row.ConID);
                    const avatarColor = stringToColor(row.clientFirmName || 'C');
                    const initials = getInitials(row.clientFirmName);
                    const locationText = [row.clientCity, row.clientState].filter(Boolean).join(', ') || '—';

                    return (
                        <Card onClick={() => { navigate(`/main/edit-consignee/${row.ConID}/${row.PartyID}`, { state: { partyId: row.PartyID } }) }}
                            key={row.ConID} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, borderLeft: '4px solid', borderLeftColor: 'primary.main', cursor: 'pointer' }}
                        >
                            <CardContent sx={{ py: 1.8, px: 2, pb: '12px !important' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        {role !== 'User' && (
                                            <Checkbox checked={isSelected} onChange={() => toggleSelection(row.ConID)} onClick={(e) => e.stopPropagation()} size="small" sx={{ mr: 1, p: 0.5 }} />
                                        )}
                                        <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, fontWeight: 'bold', mr: 1.5, flexShrink: 0 }} >
                                            {initials}
                                        </Avatar>
                                        <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.primary' }} >
                                                {row.clientFirmName || '—'}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.3 }} >
                                                {locationText}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PersonIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
                                            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }} >
                                                {row.clientContactPerson || '—'}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon fontSize="small" sx={{ color: 'primary.main', mr: 1 }} />
                                            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }} >
                                                {row.clientMobileNo || '—'}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <ReceiptIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />
                                        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }} >
                                            GST: {row.clientGSTNo || '—'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Mobile Pagination Controls */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2 }}>
                    <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))} disabled={mobilePaginationModel.page === 0} style={{ padding: '8px 12px', cursor: mobilePaginationModel.page === 0 ? 'not-allowed' : 'pointer', opacity: mobilePaginationModel.page === 0 ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
                        ← Previous
                    </button>

                    <Typography variant="body2" sx={{ minWidth: '150px', textAlign: 'center' }}>
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))} disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount} style={{ padding: '8px 12px', cursor: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 'not-allowed' : 'pointer', opacity: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
                        Next →
                    </button>
                </Box>
            </>
        );
    };

    // ============ RENDER ============

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            {/* Toolbar */}

            <Box sx={{ position: 'relative', mb: 0.7 }}>
                {/* Icons - Absolute positioned on the left */}
                <Box sx={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    gap: 0.3,
                    zIndex: 1
                }}>
                    <Tooltip title="Add New Consigne">
                        <IconButton component={RouterLink} to="/main/consignee-master" sx={{ color: "orange" }}>
                            <VscNewFile size={25} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Export to Excel">
                        <IconButton onClick={handleExport} color="success">
                            <FaFileExcel size={22} />
                        </IconButton>
                    </Tooltip>
                </Box>

                {/* Title - Centered */}
                <Typography
                    variant="h5"
                    sx={{
                        textAlign: 'center',
                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                        fontWeight: 600
                    }}
                >
                    Consignee Details
                </Typography>

            </Box>

            {/* Content */}
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {/* Mobile Search Field */}
                    {isSmallScreen && (
                        <Box sx={{ mb: 2, px: 1 }}>
                            <TextField fullWidth size="small" placeholder="Search consignees..." value={mobileSearchQuery} onChange={(e) => setMobileSearchQuery(e.target.value)} variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    )}

                    {/* Debug Info */}
                    {/* {isSmallScreen && (
                        <Box sx={{ mb: 2, p: 1, bgcolor: '#f0f0f0', borderRadius: 1, fontSize: '0.75rem' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                Debug: Search="{debouncedMobileSearch}" | Page={mobilePaginationModel.page} | Rows={rows.length} | Total={totalCount} | Loading={loading ? 'Yes' : 'No'}
                            </Typography>
                        </Box>
                    )} */}

                    {/* Bulk Action Bar - Mobile Only */}
                    {isSmallScreen && role !== 'User' && selectionModel.size > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.size} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton 
                                onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setConfirmOpen(true);
                            }} color="error">
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile View - Cards */}
                    {isSmallScreen ? (
                        <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
                            {renderCards()}
                        </Box>
                    ) : (
                        /* Desktop View - CommonServerDataGrid */
                        // <Box sx={{ height: '81.5vh', width: '100%' }}>
                        //       {rows?.length === 0 && !isFiltered ? <NoDataComponent /> :
                        //     <CommonServerDataGrid
                        //         data={rows}
                        //         columns={columns}
                        //         getRowId={(row) => row.ConID}
                        //         role={role}
                        //         pageSizeOptions={[25, 50, 100]}
                        //         selectionModel={Array.from(selectionModel)}   // DataGrid gets array
                        //         onSelectionModelChange={(newSelection) => {
                        //             setSelectionModel(new Set(newSelection));   // You keep Set
                        //         }}
                        //         onPageChange={({ page, pageSize }) => {
                        //             setPaginationModel({ page, pageSize });
                        //         }}
                        //         onFilterChange={setFilterModel}
                        //         onSortChange={setSortModel}
                        //         rowCount={totalCount}
                        //          onFilterStatusChange={setIsFiltered} 
                        //     />}
                        // </Box>

                        <Box sx={{ height: '81.5vh', width: '100%' }}>
                            {
                                rows?.length === 0 && !isFiltered ? (
                                    <NoDataComponent />
                                ) : (
                                    <CommonServerDataGrid
                                        data={rows}
                                        columns={columns}
                                        getRowId={(row) => row.ConID}
                                        role={role}
                                        pageSizeOptions={[25, 50, 100]}
                                        selectionModel={Array.from(selectionModel)}   // DataGrid gets array
                                        onSelectionModelChange={(newSelection) => {
                                            setSelectionModel(new Set(newSelection));   // You keep Set
                                        }}
                                        onPageChange={({ page, pageSize }) => {
                                            setPaginationModel({ page, pageSize });
                                        }}
                                        onFilterChange={setFilterModel}
                                        onSortChange={setSortModel}
                                        rowCount={totalCount}
                                        onFilterStatusChange={setIsFiltered}
                                    />
                                )
                            }

                        </Box>
                    )}
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

              <Dialog
                            open={confirmOpen}
                            onClose={() => setConfirmOpen(false)}
                            maxWidth="xs"
                            fullWidth
                        >
                            <DialogTitle>Confirm Deletion</DialogTitle>
            
                            <DialogContent>
                                <Typography variant="body2">
                                    Are you sure you want to delete{' '}
                                    <strong>{selectionModel.size}</strong> HSN record(s)?
                                </Typography>
                            </DialogContent>
            
                            <DialogActions>
                                <Button onClick={() => setConfirmOpen(false)} variant='outlined'>
                                    Cancel
                                </Button>
            
                                <Button
                                    color="error"
                                    variant="contained"
                                    onClick={handleDelete}
                                >
                                    Delete
                                </Button>
                            </DialogActions>
                        </Dialog>
            
        </Box>
    );
}